import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
const ViewMyH2H = (props) => {
  return (
    <>
      <Modal
        show={props.show}
        onHide={() => props.handleClose(false)}
        size="lg"
      >
        <Modal.Header>
          {" "}
          H2H-Round {props?.roundDetails.round} (
          {moment(props?.roundDetails.start_date).format("MMM D")}-
          {moment(props?.roundDetails.end_date).format("MMM D")})
        </Modal.Header>
        <Modal.Body>
          <div className="card-body">
            <div className="match_detail">
              <ul>
                <li>
                  <div className="matchdetailbox">
                    <figure className="price_image">
                      <img src="images/rank_male.png" alt="img" />
                    </figure>
                    <h5>{props.modalDetails?.first_opponent}</h5>
                  </div>

                  {props.modalDetails.total_points_first_member >
                  props.modalDetails.total_points_second_member ? (
                    <h6 className="winnerPlayer">
                      {props.modalDetails.total_points_first_member}
                    </h6>
                  ) : (
                    <h6 className="orange">
                      {props.modalDetails.total_points_first_member}
                    </h6>
                  )}
                </li>
                <li>
                  <div className="match_vs">
                    <span>vs</span>
                  </div>
                </li>
                <li>
                  <div className="matchdetailbox">
                    <figure className="price_image">
                      <img src="images/rank_male.png" alt="img" />
                    </figure>
                    <h5>{props.modalDetails?.second_opponent}</h5>
                  </div>

                  {props.modalDetails.total_points_second_member >
                  props.modalDetails.total_points_first_member ? (
                    <h6 className="winnerPlayer">
                      {props.modalDetails.total_points_second_member}
                    </h6>
                  ) : (
                    <h6 className="orange">
                      {props.modalDetails.total_points_second_member}
                    </h6>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Link
              className="border-btn"
              onClick={() => props.handleClose(false)}
            >
              Close
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewMyH2H;
